query GetStagesetStarters {
    stagesetStarters {
        type
        name
        description
    }
}
